import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import Layout from "../../components/Layout.js";
import MenuDots from "../../components/MenuDots.js";
import ModalUsuario from "../../components/Modais/ModalUsuario.js";
import Search from "../../components/Form/Search.js";
import ToggleSwitch from "../../components/ToggleSwitch.js";
import "../../assets/styles/pages/Usuarios.scss";
import "pure-css-loader/src/loader-default.sass";
import business from "../../services/business.js";
import { toast as alert } from "react-toastify";
import config from "../../config/config.js";
import InputForm from "../../components/Form/InputForm.js";
import Loading from "../../components/Loading.js";

export default function UsuariosOperadoras() {
  document.title = "säästo";
  const [pager, setPager] = useState({
    page: 1,
    total_pages: 0,
    total_rows: 0,
  });

  const [form, setForm] = useState({});
  const [listagem, setListagem] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [usuario, setUsuario] = useState({});
  const [filtroTexto, setFiltroTexto] = useState("");
  const [filtroTipo, setFiltroTipo] = useState("");
  const [filtroOperadora, setFiltroOperadora] = useState("");
  const [loaderCsv, setLoaderCsv] = useState(false);
  const especialidade = "";
  const areaatuacao = "";

  const openModal = async (event = {}, row = {}) => {
    event?.preventDefault();
    if (row?.id) setUsuario(row);
    setShowModal(true);
  };

  const searchOperadora = async (e) => {
    e.preventDefault();
    return await business.getOperadora(e.target.value);
  }

  const setSearch = (name, data) => {
    setForm({
      ...form,
      ...{
        [`id_${name}`]: data.id,
        [`nome_${name}`]: data.nome,
      },
    });
  };

  const hideModal = async (event, reload = false) => {
    event?.preventDefault();
    setShowModal(false);
    setUsuario({});
    if (reload) {
      await getSearch();
    }
  };

  const menuItens = [
    {
      label: "Editar",
      icon: "icon-edit blue i-25",
      className: "menu-icon",
      onClick: openModal,
      disabled: !config.temPermissao("admin:usuarios_operadoras:editar"),
    },
    {
      label: "Remover",
      icon: "icon-trash blue i-25",
      className: "menu-icon",
      loader: true,
      onClick: async (e, usuario) => {
        e.stopPropagation();
        if (
          !usuario?.id ||
          !window.confirm("Deseja realmente remover o usuário?")
        ) {
          return false;
        }
        let request = await business.removerUsuario(usuario.id);
        if (request && request.response?.status) {
          getSearch();
        } else if (request && request?.errors?.length) {
          alert.error(request?.errors[0]);
        }
      },
      disabled: !config.temPermissao("admin:usuarios_operadoras:excluir"),
    },
  ];

  const handlePageClick = (e) => {
    getSearch(e.selected + 1);
  };

  const getSearch = async (page = null, texto = filtroTexto, tipo = filtroTipo, especialidade = "", areaatuacao = "", operadora = filtroOperadora, loading = true) => {
    setLoading(loading);

    const tipos = tipo === "" ? [2, 3] : [tipo];

    let usuarios = await business.getAllUsuarios(
      page === null ? pager.page : page,
      10,
      texto,
      tipos,
      especialidade,
      areaatuacao,
      operadora
    );

    setListagem(usuarios?.response || []);
    if (
      usuarios?.response &&
      pager.page &&
      usuarios?.pager?.paginas > 0 &&
      usuarios?.pager?.paginas < pager.page
    ) {
      pager.page = 1;
      return getSearch();
    }
    pager.page = usuarios?.pager?.pagina;
    setPager({
      page: usuarios?.pager?.pagina,
      total_pages: usuarios?.pager?.paginas,
      total_rows: usuarios?.pager?.total,
    });
    setLoading(false);
    setSearchLoading(false);
  };

  const handleWindowSizeChange = (mobileSize) => {
    let checkIsMobile = window.innerWidth < mobileSize;
    setIsMobile(checkIsMobile);
  };

  const formatPhone = (value) => {
    if (!value) return value;
    const phonePattern = /^(\d{0,2})(\d{0,5})(\d{0,4})$/;
    const matches = value.replace(/\D/g, "").match(phonePattern);
    const part1 = matches[1] ? `(${matches[1]}) ` : "";
    const part2 = matches[2] ? `${matches[2]}` : "";
    const part3 = matches[3] ? `-${matches[3]}` : "";
    return `${part1}${part2}${part3}`.trim();
  };

  useEffect(() => {
    window.addEventListener("resize", () => {
      return handleWindowSizeChange(1180);
    });
  }, []);

  const [isMobile, setIsMobile] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const visibleColumns = [
    { id: 'id', label: 'Id', visible: true },
    { id: 'nome', label: 'Nome', visible: true },
    { id: 'operadora_nome', label: 'Operadora Nome', visible: true },
    { id: 'email', label: 'Email', visible: true },
    { id: 'telefone', label: 'Telefone', visible: true },
    { id: 'telefone2', label: 'Telefone 2', visible: true },
    { id: 'cpf', label: 'CPF', visible: true },
    { id: 'cnpj', label: 'CNPJ', visible: true },
    { id: 'crm', label: 'CRM', visible: true },
    { id: 'crm_uf', label: 'CRM UF', visible: true },
    { id: 'cro', label: 'CRO', visible: true },
    { id: 'cro_uf', label: 'CRO UF', visible: true },
    { id: 'cep', label: 'CEP', visible: true },
    { id: 'logradouro', label: 'Logradouro', visible: true },
    { id: 'numero', label: 'Número', visible: true },
    { id: 'complemento', label: 'Complemento', visible: true },
    { id: 'bairro', label: 'Bairro', visible: true },
    { id: 'cidade', label: 'Cidade', visible: true },
    { id: 'uf', label: 'UF', visible: true },
    { id: 'tipo_usuario_desc', label: 'Tipo Usuário', visible: true },
    { id: 'status_usuario_desc', label: 'Status Usuário', visible: true },
    { id: 'descricao', label: 'Descrição', visible: true },
    { id: 'observacao', label: 'Observação', visible: true },
    { id: 'data_cadastro', label: 'Data Cadastro', visible: true },
    { id: 'data_atualizacao', label: 'Data Atualização', visible: true },
  ];

  const dataExport = async () => {
    return await business.exportUsuariosOperadoras({
      id_operadora: filtroOperadora || '',
      id_usuario_tipo: filtroTipo || '',
    });
  }

  const exportToCsv = async () => {
    setLoaderCsv(true);
    let filename = 'usuarios-operadoras.csv';
    let data = (await dataExport())?.response || [];

    // Filtra as colunas visíveis
    const visibleColumnsIds = visibleColumns.filter(col => col.visible).map(col => col.id);
    const filteredData = data.map(elemento => {
      const filteredElement = {};
      visibleColumnsIds.forEach(id => {
        filteredElement[id] = elemento[id];
      });
      return filteredElement;
    });

    const options = { style: 'decimal', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }
    const numberFormatter = new Intl.NumberFormat('pt-BR', options);

    const processValue = (value) => {
      if (value === null) {
        return '';
      } else if (value instanceof Date) {
        return value.toLocaleString();
      } else if (typeof value === 'number') {
        return numberFormatter.format(value);
      } else if (typeof value === 'string') {
        if (value.startsWith('+')) {
          return `'${value}`;
        } else {
          return `"${value.replace(/"/g, '""')}"`;
        }
      }
      return value;
    };

    const csvRows = [visibleColumns.filter(col => col.visible).map(col => col.label)]; // Cabeçalho
    filteredData.forEach((objeto) => {
      csvRows.push(Object.values(objeto).map(processValue));
    });

    const csvFile = csvRows.map((row) => row.join(';')).join('\n');
    const blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), csvFile], { type: 'text/csv;charset=utf-8;' });

    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
    setLoaderCsv(false);
  };

  useEffect(() => {
    (async () => {
      await getSearch();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const typeUser = [
    {
      id_usuario_tipo: 2,
      nome: "Operadora"
    },
    {
      id_usuario_tipo: 3,
      nome: "Operadora Admin"
    }
  ];

  return (
    <Layout className="view-listagem">
      {showModal && (
        <ModalUsuario show={showModal} hideModal={hideModal} dto={usuario} />
      )}
      <p className="page-title">
        Usuários / <span className="blue-text">Operadoras</span>
      </p>
      <h2 className="title flex jc-sb ai-fe black-text mb-40 gap-10">
        Usuários de operadoras
        {config.temPermissao("admin:usuarios_operadoras:cadastrar") && (
          <button
            className="btn btn-primary f700-16 mobile"
            onClick={openModal}
          >
            Cadastrar
          </button>
        )}
      </h2>
      <div className="flex ai-fc jc-sb mb-60">
        <div className="flex ai-fc gap-25">
          <div className="container-search-filter flex ai-fc jc-sb col-6" style={{ alignSelf: "flex-end" }}>
            <Search
              onChange={(value) => {
                setSearchLoading(true);
                setFiltroTexto(value);
                getSearch(1, value, filtroTipo.id_usuario_tipo, especialidade, areaatuacao, filtroOperadora, false);
              }}
              searchOnTyping={isMobile}
              loading={searchLoading}
              placeholder={'Pesquisa...'}
            />
          </div>

          <div className="col-4">
            <InputForm
              label="Tipo de usuário"
              required
              type="select"
              className="gap-25"
              name="id_type_user"
              options={typeUser}
              value={filtroTipo?.nome} // Ajuste aqui para refletir o nome, já que você está armazenando o objeto completo no estado
              model={(name, id_usuario_tipo) => {
                const selectedUser = typeUser.find(user => user.nome === id_usuario_tipo);
                if (selectedUser) {
                  setFiltroTipo(selectedUser); // Atualiza o estado de filtroTipo
                  getSearch(1, filtroTexto, selectedUser.id_usuario_tipo, especialidade, areaatuacao, filtroOperadora, true); // Passa o tipo selecionado para o getSearch
                }
              }}
            />
          </div>

          <div className="col-4">
            <InputForm
              label="Operadora"
              type="search"
              className="span-6"
              onSearch={searchOperadora}
              name="id_operadora"
              model={(...params) => {
                const idOperadora = params[0]?.id;
                setFiltroOperadora(idOperadora);
                setSearch('operadora', ...params);
                getSearch(1, filtroTexto, filtroTipo.id_usuario_tipo, especialidade, areaatuacao, idOperadora, true);
              }} />
          </div>
        </div>

        <div className="flex ai-fc gap-30 desktop" style={{ alignSelf: "flex-end" }}>
          {config.temPermissao("admin:usuarios_operadoras:cadastrar") && (
            <button className="btn btn-primary f700-16" onClick={openModal}>
              Cadastrar
            </button>
          )}
          <button className="btn btn-primary f700-16" onClick={exportToCsv} disabled={loaderCsv}>
            {loaderCsv ? <Loading /> : <i className="icon icon-document i-25" />}<span className="pl-5">Exportar</span>
          </button>
        </div>
      </div>

      {loading ? (
        <div className="loader loader-default is-active" />
      ) : (
        <div>
          <div className="table-mobile">
            {listagem.map((p, i) => {
              return (
                <div className="item pointer" key={`mobile-${i}`}>
                  <div>
                    <div className="fn-16 linha flex jc-sb">
                      Nome
                      <span>{p.nome}</span>
                    </div>
                    <div className="fn-16 linha flex jc-sb">
                      Telefone
                      <span>{formatPhone(p.telefone) || "-"}</span>
                    </div>
                    <div className="fn-16 linha flex jc-sb">
                      E-mail
                      <span>{p.email}</span>
                    </div>
                    <div className="fn-16 linha flex jc-sb">
                      Operadora
                      <span>{p.desc_operadora}</span>
                    </div>
                    <div className="fn-16 linha flex jc-sb">
                      Perfil de acesso
                      <span
                        className={`tag-perfil ${(
                          p.perfil || ""
                        ).toLowerCase()}`}
                      >
                        {p.perfil}
                      </span>
                    </div>
                    <div className="fn-16 linha flex jc-sb">
                      Status
                      <span>
                        <ToggleSwitch
                          type="checkbox"
                          id={"mobile-" + p.id}
                          name="status"
                          disabled={
                            parseInt(p.id_usuarios_tipo) === 1 ||
                            !config.temPermissao("admin:usuarios_operadoras:editar")
                          }
                          value={parseInt(p.id_status) === 1 ? true : false}
                          texto={["Ativo", "Inativo"]}
                          style={{ "--width": "110px" }}
                          model={async (name, data) => {
                            listagem[i].id_status = data ? 1 : 2;
                            let request = await business.statusUsuario(
                              listagem[i].id_status,
                              listagem[i].id
                            );
                            if (request?.response?.status) {
                              setListagem([...listagem]);
                            }
                          }}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="w-100 flex jc-fc">
                    <MenuDots
                      row={p}
                      menuItens={menuItens}
                      menuPositionTop={true}
                    />
                  </div>
                </div>
              );
            })}
            {(!listagem || !listagem?.length) && (
              <div className="item pointer" key={`mobile-0`}>
                Nenhum resultado encontrado.
              </div>
            )}
          </div>
          <table className="w-100 table-desktop">
            <thead className="f300-16">
              <tr>
                <th className="bold">Nome</th>
                <th className="text-left bold">Telefone</th>
                <th className="text-left bold">E-mail</th>
                <th className="text-left bold">Operadora</th>
                <th className="text-center bold">Perfil de acesso</th>
                <th className="text-center bold">Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {listagem.map((p, i) => {
                return (
                  <tr key={`desktop-${i}`} onClick={openModal}>
                    <td className="fn-16">{p.nome}</td>
                    <td className="fn-16">{formatPhone(p.telefone) || "-"}</td>
                    <td className="fn-16 underline">{p.email}</td>
                    <td className="fn-16">{p.desc_operadora}</td>
                    <td className="fn-16 text-center">
                      <span
                        className={`tag-perfil ${(
                          p.desc_usuarios_tipo || ""
                        ).toLowerCase()}`}
                      >
                        {p.desc_usuarios_tipo}
                      </span>
                    </td>
                    <td className="fn-16 text-center" style={{ minWidth: "120px" }} onClick={(e) => e.stopPropagation()}>
                      <ToggleSwitch
                        type="checkbox"
                        id={"desktop-" + p.id}
                        name="status"
                        disabled={
                          parseInt(p.id_usuarios_tipo) === 1 ||
                          !config.temPermissao("admin:usuarios_operadoras:editar")
                        }
                        value={parseInt(p.id_status) === 1 ? true : false}
                        texto={["Ativo", "Inativo"]}
                        style={{ "--width": "110px" }}
                        model={async (name, data) => {
                          listagem[i].id_status = data ? 1 : 2;
                          let request = await business.statusUsuario(
                            listagem[i].id_status,
                            listagem[i].id
                          );
                          if (request?.response?.status) {
                            setListagem([...listagem]);
                          }
                        }}
                      />
                    </td>
                    <td className="text-center" style={{ width: "35px" }}>
                      <MenuDots
                        row={p}
                        menuItens={menuItens}
                        menuPositionTop={listagem.length - i <= 2}
                      />
                    </td>
                  </tr>
                );
              })}
              {(!listagem || !listagem?.length) && (
                <tr>
                  <td colSpan={7}>Nenhum resultado encontrado.</td>
                </tr>
              )}
            </tbody>
          </table>
          <div className="component pagination">
            <div className="pagination-container mt-30">
              {pager.total_pages < 2 ? (
                ""
              ) : (
                <ReactPaginate
                  previousLabel="«"
                  nextLabel="»"
                  breakLabel="..."
                  breakClassName="break-me"
                  page={pager.page - 1 ?? 0}
                  forcePage={pager.page - 1 ?? 0}
                  pageCount={pager.total_pages}
                  marginPagesDisplayed={3}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageClick}
                  containerClassName="pagination"
                  subContainerClassName="pages pagination"
                  activeClassName="active"
                />
              )}
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
